import axios from "axios";
import ConstantList from "../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/download-file";

export const exportPatientDataRawList = (searchObject) => {
  var url = API_PATH + "/export-patient-data-raw-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: searchObject,
  });
};